export default __webpack_public_path__ + "static/media/bonus_approved.4d00a1f1.svg";